// extracted by mini-css-extract-plugin
export default {"headerWrap":"Header_headerWrap__WUHXD","title":"Header_title__5H5Nw","shareWrap":"Header_shareWrap__qN1F4","icon":"Header_icon__GC5GI","txt":"Header_txt__ALTl2"};